import { useEffect, useState } from 'react';
import { FiArrowRight, FiFileText, FiFolder, FiUser } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { fetchAdminProjects } from '../api/admin';
import styles from './AdminConsole.module.css';

const AdminConsole = () => {
  const [projectCount, setProjectCount] = useState(null);

  useEffect(() => {
    let active = true;
    fetchAdminProjects()
      .then((response) => {
        if (active && response.data?.code === 200) setProjectCount(response.data.data?.length || 0);
      })
      .catch(() => { if (active) setProjectCount(null); });
    return () => { active = false; };
  }, []);

  return (
  <div>
    <header className={styles.pageHeader}>
      <div>
        <p>WELCOME BACK</p>
        <h1>Keep your work clear and current.</h1>
        <span>Manage the writing and projects published on CodeCognition.</span>
      </div>
      <Link to="/admin/posts/new" className={styles.primaryAction}>New article</Link>
    </header>

    <section className={styles.overviewGrid} aria-label="Content overview">
      <Link to="/admin/posts" className={styles.overviewCard}>
        <FiFileText />
        <div><strong>Articles</strong><span>Write, edit and publish technical notes.</span></div>
        <FiArrowRight />
      </Link>
      <Link to="/admin/projects" className={styles.overviewCard}>
        <FiFolder />
        <div><strong>{projectCount === null ? 'Projects' : `${projectCount} Project${projectCount === 1 ? '' : 's'}`}</strong><span>Maintain case studies and architecture.</span></div>
        <FiArrowRight />
      </Link>
      <Link to="/admin/profile" className={styles.overviewCard}>
        <FiUser />
        <div><strong>Profile</strong><span>Update identity, location and About content.</span></div>
        <FiArrowRight />
      </Link>
    </section>

    <section className={styles.notePanel}>
      <div><span>01</span><h2>A deliberately small admin.</h2></div>
      <p>This workspace manages articles, projects and the personal profile used across the public site.</p>
    </section>
  </div>
  );
};

export default AdminConsole;
